import React, { useRef, useState, useEffect } from "react";
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from 'moment';
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Alert, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt } from '@fortawesome/free-solid-svg-icons'
import QrScanner from 'components/QrScanner';


import LoaderButton from "./LoaderButton";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';

// import "./Show.css";


export default function TokenScanner({show, onClose, ...props}) {
    
    const [token, setToken] = useState(null);
    const [status, setStatus] = useState('loading');

    const [isLoading, setIsLoading] = useState(false); 

    async function validateCode(code, show_uid) {
        try {
            // const redeem = '&redeem=1'
            const tokens = '&tokens=1'
            const result = await API.get("vivelo", 
                `/etickets/tokens/qr/redeem/${code}?s=${show_uid}${tokens}`);
            return result
        } catch (e) {
            console.log(e)
            if (e.response.data) {
                return e.response.data
            } else {
                return {
                    success: false,
                    allow_access: false
                    
                }
            }
        }
    }

    function handleStatusChange(status) {
        if (status.scanning) {
            setStatus('scanning')
            setToken(null)
        }
    }

    async function handleOnSuccess(payload) {
        setStatus('validating')

        // const show_uid = '5fa745164a298a7ef36d8a5f'
        // const ticket_uid = '5fa745194a298a7ef36d8a61' 
        // const ticket_uid = '5fa745194a298a7ef36d8a60' 
        const show_uid = show._id
        const code = payload.raw
        const result = await validateCode(code, show_uid)

        if (result.success) {
            result.code = code.substring(4,11)
            setToken(result)
            setStatus('accepted')
        } else {
            console.log(result)
            result.code = code.substring(4,11)
            setToken(result)
            if (result.balance === 0) {
                setStatus('rejected')
            } else {
                setStatus('invalid')
            }
            
        }
    }

    function exitScanner() {
        setToken(null)
        setStatus('loading')
        onClose()
        // setShowTicket(null)
    }

    function renderStatusBar() {
        switch(status) {
            case 'scanning':
                return <Alert variant="info"><FontAwesomeIcon icon={faQrcode} /> Acerca el código a la cámara</Alert>
            case 'validating':
                return <Alert variant="primary"><FontAwesomeIcon icon={faSpinner} className="spinning" /> Validando...</Alert>
            case 'accepted':
                return <Alert variant="success"><FontAwesomeIcon icon={faCheckCircle} /> Token válido</Alert>
            case 'warning':
                return <Alert variant="warning"><FontAwesomeIcon icon={faExclamationTriangle} /> Existe un problema con el token</Alert>
            case 'rejected':
                return <Alert variant="danger"><FontAwesomeIcon icon={faTimesCircle} /> Saldo Insuficiente</Alert>
            case 'invalid':
                return <Alert variant="danger"><FontAwesomeIcon icon={faTimesCircle} /> Token inválido</Alert>
            default: 
                return <Alert variant="primary"><FontAwesomeIcon icon={faSpinner} className="spinning" /> Cargando...</Alert>
        }
    }

    function renderScanner() {
        
        return show && <div className="scanner-container">                
                
                {<div className="show-admission">
                    <div className="show-admission-header">                        
                        <h1>{show.fullname}</h1>
                        <Button onClick={exitScanner} className="exit" variant="outline-light">Cerrar</Button>
                        <h2>Tokens</h2>
                    </div>
                    
                    <div className={`show-admission-scanner ${status}`}>
                        <QrScanner 
                            size={250}
                            pattern="(WT01)([ABCDEFGHIJKLMNPQRSTUVWXYZ123456789]{6})"
                            onSuccess={handleOnSuccess}
                            onStatusChange={handleStatusChange}
                        />
                    </div>
                    <div className="show-admission-result">
                        <div>
                            {renderStatusBar()}
                        </div>
                        <div className="show-admission-ticket-info">
                        {token && <div className="ticket-data">                            
                            <div className="ticket-data-item"><label>Código</label><span>{token.code}</span></div>
                            <div className="ticket-data-item"><label>Saldo</label><span>{token.balance}</span></div>                            
                        </div> }                        
                        </div>
                    </div>
                </div> }
        </div>
    }

    return renderScanner()

}